import { render, staticRenderFns } from "./BlockchainDashboard.vue?vue&type=template&id=36ee684d&scoped=true"
import script from "./BlockchainDashboard.vue?vue&type=script&lang=js"
export * from "./BlockchainDashboard.vue?vue&type=script&lang=js"
import style0 from "./BlockchainDashboard.vue?vue&type=style&index=0&id=36ee684d&prod&lang=css"
import style1 from "./BlockchainDashboard.vue?vue&type=style&index=1&id=36ee684d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ee684d",
  null
  
)

export default component.exports